<template>
	<div class="new-tool-form">
		<form>
			<div class="form-header">
				<section>
					<div class="tw-flex">
						<div class="number-process font-weight-bold tw-text-center text-white">
							1
						</div>
						<div class="ml-3 w-100">
							<h3 class="section-title font-weight-bold mb-3 pb-2"
								:style="`border-bottom:1px solid ${$appColors.gray}`"
							>NOMBRE DE COMITÉ</h3>
						</div>
					</div>
					<div class="code mt-3">
						<label for="new-tool-code"
							:style="`color:${$appColors.info}`"
						>
							Nombre de Comité
							<input
								id="new-tool-code"
								class="new-survey-input"
								placeholder="Código"
								v-model="newCommitee.name"
							/>
						</label>
					</div>
				</section>
			</div>
			<div class="form mt-4">
				<section class="general-section">
					<div class="tw-flex">
						<div class="number-process font-weight-bold tw-text-center text-white">
							2
						</div>
						<div class="ml-3">
							<h3 class="section-title font-weight-bold mb-3 pb-2"
								:style="`border-bottom:1px solid ${$appColors.gray}`"
							>SELECCIONAR PUESTOS A VALORAR</h3>
						</div>
					</div>
					<div class="label-commitees mb-2">
						Seleccionar las personas encargadas de valorar los puestos
					</div>
					<label :style="`color:${$appColors.primary};`">AGREGA PUESTOS</label>
					<div class="container-search mt-2">
						<label class="video-label"
							:style="`color:${$appColors.info}`"
						>
							Buscar Puestos
							<v-autocomplete
								dense
								class="autocomplete-select"
								background-color="white"
								box
								:height="37"
								append-icon="search"
								autocomplete
								return-object
								:items="stalls"
								item-value="id"
								item-text="name"
								v-model="newCommitee.job"
								hide-details
							>
								<template slot="item" slot-scope="props">
									<v-list-tile-content :class="{ 'disabled-item': props.item.disabled }">
										<v-list-tile-title>
											<div>{{ props.item.name }}</div>
										</v-list-tile-title>
									</v-list-tile-content>
								</template>
							</v-autocomplete>
						</label>
						<app-button
							:disabled="!newCommitee.job"
							class="video-btn ml-3"
							icon="add"
							@click="addJobs"
						/>
						<div class="video-link-container mt-2"
						v-for="(item, indexVi) in newCommitee.jobs"
						:key="indexVi">
							<div
								class="videos-link tw-flex tw-justify-between tw-items-center"
							>
								<div :style="`color:${$appColors.info}`">
									{{ item.name }}
								</div>
								<div>
									<app-tooltip-button
										:img="`${$imageUrl}/delete-button.svg`"
										text="Eliminar"
										@click-icon="deleteJobs(indexVi)"
									/>
								</div>
							</div>
						</div>
					</div>
				</section>
				<section class="media-section ml-5">
					<div class="tw-flex">
						<div class="number-process font-weight-bold tw-text-center text-white">
							3
						</div>
						<div class="ml-3">
							<h3 class="section-title font-weight-bold mb-3 pb-2"
								:style="`border-bottom:1px solid ${$appColors.gray}`"
							>SELECCIONAR MIEMBROS DE COMITÉ</h3>
						</div>
					</div>
					<div class="label-commitees mb-2">
						Seleccionar las personas encargadas de valorar los puestos
					</div>
					<label :style="`color:${$appColors.primary};`" class="mt-2">AGREGAR MIEMBRO DE COMITÉ</label>
					<div class="container-search mt-2">
						<label class="video-label"
							:style="`color:${$appColors.info}`"
						>
							Buscar Encargados
							<v-autocomplete
								class="autocomplete-select"
								background-color="white"
								box
								hide-details
								append-icon="search"
								autocomplete
								return-object
								:items="members"
								item-text="name"
								item-value="id"
								v-model="newCommitee.employee"
							>
								<template slot="item" slot-scope="props">
									<v-list-tile-content :class="{ 'disabled-item': props.item.disabled }">
										<v-list-tile-title>
											<div>{{ props.item.name }}</div>
										</v-list-tile-title>
									</v-list-tile-content>
								</template>
							</v-autocomplete>
						</label>
						<app-button
							:disabled="!newCommitee.employee"
							class="video-btn ml-3"
							icon="add"
							@click="addEmployees"
						/>
						<div class="video-link-container mt-2"
						v-for="(item, indexVi) in newCommitee.stalls"
						:key="indexVi"
						>
							<div
								class="videos-link tw-flex tw-justify-between tw-items-center"
							>
								<span :style="`color:${$appColors.info}`">
									{{ item.name }}
								</span>
									<app-tooltip-button
										:img="`${$imageUrl}/delete-button.svg`"
										text="Eliminar"
										@click-icon="deleteStalls(indexVi)"
									/>
							</div>
						</div>
					</div>
				</section>
			</div>
		</form>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:is-loading="repeatName || newCommitee.stalls.length === 0 || newCommitee.jobs.length === 0"
				cancel-text="Atrás"
				success-color="primary"
				:success-text="idCommitee ? 'Actualizar' : 'Guardar'"
				@cancel-button-clicked="goBack"
				@accept-button-clicked="createCommitee"
			></modal-sidebar-button>
		</section>
	</div>
</template>

<script>
	import appButton from '@/components/shared/app-button';

	function created() {
		const { id } = this.$route.params;
		this.idCommitee = id;
		if (id) {
			this.loadEditCommitee(id);
		}
		this.loadStalls();
		this.loadEmployees();
	}

	async function loadEditCommitee(id) {
		try {
			const { data: response } = await this.$httpPraktiko.get(`groups/${id}`);
			const { name, jobs, committeeEmployees, totalMale, totalFemale } = response;
			this.newCommitee.name = name;
			this.newCommitee.stalls = committeeEmployees.length > 0 ? committeeEmployees : [];
			this.newCommitee.jobs = jobs.length > 0 ? jobs : [];
			this.totalMale = totalMale || 0;
			this.totalFemale = totalFemale || 0;
		} catch (error) {
			this.showGenericError();
		}
	}

	async function loadStalls() {
		const params = {
			typeGroup: 2,
		};
		const { data: response } = await this.$httpPraktiko.get('groups', { params });
		this.stalls = response.map((s) => {
			const newS = { ...s };
			newS.disabled = false;
			return newS;
		});
		if (this.newCommitee.jobs.length > 0) {
			this.stalls = this.stalls.map((s) => {
				const isDisabled = this.newCommitee.jobs.some(j => j.id === s.id);
				const newS = { ...s };
				newS.disabled = isDisabled;
				return newS;
			});
		}
	}

	async function loadEmployees() {
		const { data: response } = await this.$httpPraktiko.get('employee');
		this.members = response.map((m) => {
			const newM = { ...m };
			newM.diabled = false;
			return newM;
		});
		if (this.newCommitee.stalls.length > 0) {
			this.members = this.members.map((s) => {
				const isDisabled = this.newCommitee.stalls.some(j => j.id === s.id);
				const newS = { ...s };
				newS.disabled = isDisabled;
				return newS;
			});
		}
	}

	function formTitle() {
		return this.idCommitee ? 'Editar Comité' : this.$route.meta.title;
	}

	async function createCommitee() {
		const url = this.idCommitee ? `groups/${this.idCommitee}` : 'groups';
		const method = this.idCommitee ? 'patch' : 'post';
		const message = this.idCommitee ? 'actualizo' : 'creó';
		const body = {
			name: this.newCommitee.name,
			code: this.newCommitee.name.replace(/ /g, '-'),
			jobs: this.newCommitee.jobs.map(p => p.id),
			employees: this.newCommitee.stalls.map(q => q.id),
		};
		if (this.idCommitee) {
			delete body.code;
			body.totalFemale = this.totalFemale;
			body.totalMale = this.totalMale;
		}
		try {
			await this.$httpPraktiko[method](url, body);
			this.goTo('job-evaluation-processes-commitees');
			this.showNotification(`El comité se ${message} correctamente.`);
			this.repeatName = false;
		} catch (error) {
			if (error.status === 400) {
				if (error.data.message === 'GROUP_CODE_REPEATED') {
					this.repeatName = true;
					this.showNotification('El nombre del comité ya existe', 'warning');
				} else if (this.newCommitee.jobs.length === 0) {
					this.showNotification('Debe agregar al menos un puesto', 'warning');
				} else if (this.newCommitee.stalls.length === 0) {
					this.showNotification('Debe agregar al menos un encargado', 'warning');
				} else {
					this.showGenericError();
				}
			} else {
				this.showGenericError();
			}
		}
	}

	function flagEdit(flag) {
		if (flag) {
			this.newCommitee = { ...this.editingData };
		}
	}

	function addEmployees() {
		const { name, id } = this.newCommitee.employee;
		this.newCommitee.stalls.push({ name, id });
		this.newCommitee.employee = null;
		for (let i = 0; i < this.newCommitee.stalls.length; i += 1) {
			for (let j = 0; j < this.members.length; j += 1) {
				if (this.newCommitee.stalls[i].name === this.members[j].name) {
					this.members[j].disabled = true;
				}
			}
		}
	}

	function addJobs() {
		const { name, id } = this.newCommitee.job;
		this.newCommitee.jobs.push({ name, id });
		this.newCommitee.job = null;
		for (let i = 0; i < this.newCommitee.jobs.length; i += 1) {
			for (let j = 0; j < this.stalls.length; j += 1) {
				if (this.newCommitee.jobs[i].name === this.stalls[j].name) {
					this.stalls[j].disabled = true;
				}
			}
		}
	}

	function goBack() {
		this.$router.back();
	}

	function deleteStalls(index) {
		const id = this.newCommitee.stalls[index].id;
		for (let j = 0; j < this.members.length; j += 1) {
			if (this.members[j].id === id) {
				this.members[j].disabled = false;
			}
		}
		this.newCommitee.stalls.splice(index, 1);
	}

	function deleteJobs(index) {
		const id = this.newCommitee.jobs[index].id;
		for (let j = 0; j < this.stalls.length; j += 1) {
			if (this.stalls[j].id === id) {
				this.stalls[j].disabled = false;
			}
		}
		this.newCommitee.jobs.splice(index, 1);
	}

	function data() {
		return {
			idCommitee: null,
			members: [],
			newCommitee: {
				name: '',
				job: null,
				stalls: [],
				jobs: [],
			},
			stalls: [],
			repeatName: false,
			totalMale: null,
			totalFemale: null,
		};
	}

	export default {
		name: 'new-form-commitees',
		created,
		components: {
			appButton,
		},
		computed: {
			formTitle,
		},
		methods: {
			addEmployees,
			addJobs,
			createCommitee,
			deleteJobs,
			deleteStalls,
			goBack,
			loadEditCommitee,
			loadEmployees,
			loadStalls,
		},
		watch: {
			flagEdit,
		},
		data,
	};
</script>

<style lang="scss" scoped>
.new-tool-form {
	background-color: white;
	border: 1px solid #e9e9e9;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);
	margin-bottom: 21px;
	padding: 44px 0;

	.new-tool-form-title {
		font-family: font(bold);
		font-size: size(xlarge);
		margin-bottom: 22px;
		padding: 0 33px 12px;
	}

	label {
		font-size: size(small);

		input::placeholder {
			font-size: size(medium);
		}
	}

	.form {
		align-items: flex-start;
		display: flex;
		padding: 0 38px;

		.general-section, .media-section {
			flex-basis: 50%;
			// padding: 0 10px;
		}

		.w-100 {
			width: 100% !important;
		}
	}
}

.form-header {
	padding: 0 38px;
}

.number-process {
	background-color: #55ac4b;
	border-radius: 50%;
	height: 33px;
	font-size: 18px;
	padding-top: 2px;
	width: 33px;
}

.w-100 {
	width: 100%;
}

.container-search {
	align-items: flex-end;
	display: flex;
	flex-wrap: wrap;
}

.video-label {
	flex-basis: 89%;
}

.section-title {
	color: #545a54;
}

.img-link-container, .video-link-container {
	align-items: center;
	border: 1px solid #cdcdcd;
	padding: 0 15px 0 26px;
	width: 100%;
}

.video-btn {
	border-radius: 3px !important;
	height: 25px !important;
	width: 25px;
}

.label-commitees {
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12);
	font-size: 12px;
	padding: 9px 21px;
}
.disabled-item {
	background-color: #e0e0e0 !important;
	color: #a0a0a0 !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/commitees/new-form-commitees.vue